import React, { Component } from 'react';
import './styles.css';
import { Alert, AlertTitle, Button, IconButton, MenuItem, Stack, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import imgPenunjang from '../../assets/penunjang.jpg';
import imgRadiologi from '../../assets/imgRadiologi.jpg';
import imgLab2 from '../../assets/imgLab2.jpg';
import Register from '../Register';
import { onValue, ref } from 'firebase/database';
import StartFirebaseUser from '../../configUserFirebase/index';

const db = StartFirebaseUser();

class Login extends Component {
  state = {
    username: '',
    password: '',
    showpass: false,
    errorLogin: false,
    successLogin: false,
    register: false,
    penunjang: '',
    dataTable: []
  }

  componentDidMount() {
    const dbRef = ref(db, 'user');
    onValue(dbRef, (snapshot) => {
      let records = [];
      snapshot.forEach(childSnapshot => {
        let data = childSnapshot.val();
        records.push(data);
      });
      this.setState({ dataTable: records })
    });
  }

  _handleChangeLogin = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  _handleLogin = () => {
    const { username, password, penunjang, dataTable } = this.state;
    const checkUser = dataTable?.filter(val =>
      val?.username === username &&
      val?.password === password &&
      val?.penunjang === penunjang &&
    val?.unit === 'penunjang')?.length === 1;
    if (checkUser) {
      localStorage.setItem('login', true);
      localStorage.setItem('penunjang', penunjang);
      localStorage.setItem('username', username);
      this.setState({ successLogin: true }, () => {
        setTimeout(() => window.location.reload(), 3000)
      });
    } else {
      this.setState({ errorLogin: true }, () => {
        setTimeout(() => this.setState({ errorLogin: false }), 3000)
      });
    }
  }

  _handleShowPass = () => {
    this.setState({ showpass: !this.state.showpass });
  }

  _renderAlertSuccess = () => {
    const { penunjang } = this.state;
    return (
      <Stack sx={{ position: 'absolute', top: 10, right: '35%' }} spacing={2}>
        <Alert severity="success">
          <AlertTitle>Login Berhasil!</AlertTitle>
          Anda akan dialihkan ke halaman Unit Penunjang {penunjang}
        </Alert>
      </Stack>
    );
  }

  _renderAlertError = () => {
    return (
      <Stack sx={{ position: 'absolute', top: 10, right: '35%' }} spacing={2}>
        <Alert severity="error">
          <AlertTitle>Login Gagal!</AlertTitle>
          Cek kembali Username dan Password yang Anda masukkan.
        </Alert>
      </Stack>
    );
  }

  _handleChange = (e) => {
    this.setState({ penunjang: e.target.value }, () => {
      setTimeout(() => { this._setAnimate(); }, 0);
    });
  }

  _setAnimate = () => {
    if (this.state.penunjang === 'Laboratorium') {
      document.getElementById('bgImage').style.animation = "spin2 2s linear";
    } else if (this.state.penunjang === 'Radiologi') {
      document.getElementById('bgImage').style.animation = "spin3 2s linear";
    }
  }

  _handleRegister = () => {
    this.setState({ register: !this.state.register });
  }

  _handleBack = (val) => {
    this.setState({ register: val })
  }

  render() {
    const { username, password, errorLogin, successLogin, showpass, penunjang, register } = this.state;
    let bgImg;
    if (penunjang === 'Laboratorium') { bgImg = imgLab2; }
    else if (penunjang === 'Radiologi') { bgImg = imgRadiologi; }
    else { bgImg = imgPenunjang; }

    if (register) {
      return <Register onBack={this._handleBack} />
    } else {
      return (
        <div className='container'>
          {successLogin && this._renderAlertSuccess()}
          {errorLogin && this._renderAlertError()}
          <div>
            <img alt='' className='wrapp-image' id='bgImage' src={bgImg} />
          </div>
          <div className='wrapp-form'>
            <h2>SELAMAT DATANG</h2>
            <p>Silahkan Login terlebih dahulu untuk masuk ke Unit Penunjang Rawat Jalan</p>
            <h3 style={{ marginTop: 30 }}>Pilih Unit Penunjang</h3>
            <TextField
              className='wrappField'
              id="outlined-select-currency"
              select
              label="Unit Penunjang"
              fullWidth
              name='penunjang'
              onChange={this._handleChange}
            >
              {['Laboratorium', 'Radiologi'].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            <div className='wrapp-fields'>
              <TextField
                fullWidth
                label="Username"
                name='username'
                onChange={this._handleChangeLogin}
                value={username}
                sx={{ marginBottom: '10px' }}
              />
              <div style={{ position: 'relative' }}>
                <TextField
                  fullWidth
                  label="Password"
                  type={showpass ? 'text' : 'password'}
                  name='password'
                  onChange={this._handleChangeLogin}
                  value={password}
                />
                {showpass ?
                  <IconButton
                    onClick={this._handleShowPass}
                    style={{ position: 'absolute', right: 5, top: 4, zIndex: 2 }}
                  >
                    <VisibilityOff style={{ fontSize: '30px', color: 'grey' }} />
                  </IconButton> :
                  <IconButton onClick={this._handleShowPass} style={{ position: 'absolute', right: 5, top: 4, zIndex: 2 }}>
                    <Visibility style={{ fontSize: '30px', color: 'grey' }} />
                  </IconButton>
                }
              </div>
              <div style={{ display: 'flex', fontSize: '14px', justifyContent: 'end', marginTop: '10px' }}>
                <div>Belum punya akun?</div>
                <div className="daftar" onClick={this._handleRegister}>Daftar disini</div>
              </div>
              <Button
                disabled={
                  penunjang === '' ||
                    username === '' ||
                    password === '' ? true : false
                }
                fullWidth
                variant='contained'
                onClick={this._handleLogin}
                style={{ marginTop: 20 }}
              >
                Login
              </Button>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Login;